// utils/debug.ts

// Extend the Window interface to include a "renttoday" namespace.
declare global {
  interface Window {
    renttoday: Record<string, unknown>;
  }
}

export function exposeGlobal<T>(key: string, value: T): void {
  if (process.env.NODE_ENV !== "production" && typeof window !== "undefined") {
    // Ensure the renttoday namespace exists on the window object
    window.renttoday = window.renttoday || {};
    window.renttoday[key] = value;
  }
}
